import gsap, { Power4 } from "gsap";

gsap.registerPlugin(Power4);

export default function load() {
  gsap
    .timeline()
    .set(".p-kv__copy__text", { y: 5,})
    .set(".p-kv__button", { y: 5,})
    .from("#header", { y: -100, duration: 1}, "+=.5")
    .to(".p-kv__copy__text", { y: 0, opacity: 1, duration: 2 }, "+=4.5")
    .to(".p-kv__button", { y: 0, opacity: 1, duration: 1.2 }, "-=1");
}
